import { Line } from "../../../Line";
import { Pressable } from "../../../Pressable";
import { Heading } from "../../../typography/Heading";
import { Label } from "../../../typography/Label";
import { useChat } from "../../ChatContext";
import { proposalImageClass } from "../styles";
import type { ConfirmedBooking } from "../types";

export function ConfirmedBookingCard({ booking }: { booking: ConfirmedBooking }) {
    return (
        <div className="flex w-full flex-col items-start gap-12">
            <Pressable href={booking.href} className="text-left">
                <div className="flex w-full flex-row items-center gap-12">
                    {booking.imageUrl && (
                        <img
                            src={booking.imageUrl}
                            alt={booking.title}
                            className={proposalImageClass}
                        />
                    )}

                    <Heading level={5}>{booking.title}</Heading>
                </div>
            </Pressable>

            <BookingOptions options={booking.options} />
        </div>
    );
}

function BookingOptions({ options }: { options: ConfirmedBooking["options"] }) {
    const { labels } = useChat();

    if (!options?.length) {
        return null;
    }

    return (
        <>
            <Line variant="dashed" />

            <div className="flex w-full flex-col items-start gap-12">
                <Label
                    size="xsmall"
                    weight="medium-bold"
                    color="secondary"
                    className="uppercase"
                >
                    {labels.preferredOptions}
                </Label>

                {options.map((option) => (
                    <Label
                        key={option.id}
                        size="medium"
                        weight="regular"
                        color="primary"
                    >
                        {option.title}
                    </Label>
                ))}
            </div>
        </>
    );
}
